import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { FeedItemsService } from 'src/app/shared/services/feed-items.service';
import { ResolverCacheService } from 'src/app/shared/services/resolver-cache.service';
import { FeedItemsResponseDto } from 'src/app/shared/dtos/feed-items.dto';

export const feedItemsResolver: ResolveFn<FeedItemsResponseDto | null> = () => {
  const feedItemsService = inject(FeedItemsService);
  const resolverCacheService = inject(ResolverCacheService);

  return resolverCacheService.createCachedResolver<FeedItemsResponseDto | null>(
    'feed-items',
    () => feedItemsService.getFeedItems()
  );
};
